module.exports = __webpack_public_path__ + "static/media/reel.35de52cf.wav";